import styled from "styled-components";
import { device } from "../../globalAssets/breakpoints";
import { desktop } from "../../globalAssets/fontsize";

export const Mutetext = styled.p`
  font-weight: 400;
  color: ${(props) => props.theme.grey};
  cursor: pointer;
  text-align: end;
  margin-bottom: 10px;
  font-size: 14px;
  @media ${device.laptop} {
    font-size: ${desktop.small};
    margin-bottom: 1vw;
  }
`;

export const Account = styled.p`
  color: ${(props) => props.theme.color};
  font-weight: 400;
  text-align: center;
  margin: 7px 0 7px 0;

  & > span {
    color: ${(props) => props.theme.primaryColor};
  }
  @media ${device.laptop} {
    font-size: ${desktop.small};
    cursor: pointer;
    margin: 1.4vw 0 1vw 0;
  }
`;

export const NotificationText = styled.h4`
  margin: 0;
  font-size: 16px;
  text-align: center;
  color: ${(props) => props.theme.color};
  span {
    font-weight: 600;
    color: ${(props) => props.theme.primaryColor};
  }
  @media ${device.laptop} {
    font-size: ${desktop.normal};
  }
`;

export const SocialContainer = styled.div`
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 200px;
  &  div {
    display: flex;
    align-items: center;
    padding: 5px;
    justify-content: center;
    background: ${(props) => props.theme.foreground};
    box-shadow: ${(props) => props.theme.shadow};
    border-radius: 50%;
    & > img {
      height: 20px;
    }
  }

  @media ${device.laptop} {
    width: 40%;

    & > div {
      padding: 0.3vw;

      transition: 0.2s ease-in;
      cursor: pointer;
      :hover {
        transform: scale(1.2);
        box-shadow: none;
      }
      & > img {
        height: 1.2vw;
      }
    }
  }
`;
